// footer.component.ts
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { ConstantsService } from '../../constants/constants.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterModule, RouterLink, CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  activeNavItem: string = 'home';
  
  constructor(public constants: ConstantsService, private router: Router) { }
  
  setActiveNavItem(navItem: string) {
    this.activeNavItem = navItem;
  }
  
  logout() {
    console.log('logout');
    this.constants.clearSession();
    this.router.navigate(['/splash']);
  }
  
  toggleSidebar() {
    this.setActiveNavItem('menu');
    const wrapper = document.getElementById('main-wrapper');
    if (wrapper) {
      wrapper.classList.toggle('show-sidebar');
    }
  }
  
  viewVisitsByStatus(status: string) {
    this.setActiveNavItem('pending');
    this.router.navigate(['visit-list'], {
      queryParams: {
        status: status,
      },
    });
  }
  
  navigateToSearch() {
    this.setActiveNavItem('search');
    // Add your search navigation logic here
  }
  
  navigateToAddVisit() {
    this.setActiveNavItem('add');
    this.router.navigate(['/create-visit']);
  }
  
  navigateToHome() {
    this.setActiveNavItem('home');
  }
}